import cloneDeep from 'lodash.clonedeep';
import {
  getAuditDetails,
  getAuditFieldInfo,
  AuditService,
  AuditActionType,
} from 'shared/userAudit/audit-constants';
import { Operation, AuditDetails } from 'data/types';
import { XtpXdpConnection, XtpXdpConnectionProtocol } from 'data/xtp-xdp-connection/xtp-xdp-connection.types';
import { CollectionFunction, CollectionFunctionFormData } from 'data/collectionFunction/collectionFunction.types';

export const getCFData = (data: XtpXdpConnection): CollectionFunctionFormData => {
  const newCF:CollectionFunction = {
    id: '',
    dxOwner: 'dxOwner',
    dxAccess: 'dxAccess',
    name: 'connection',
    bufferCC: false,
    cellTowerLocation: false,
    contact: {
        id: '',
        name: ''
    },
    cfGroup: undefined,
    deliveryType: 'DSR',
    country: 'US',
    stateName: '',
    city: '',
    insideNat: false,
    type: 'IPDU',
    tag: 'IPDU',
    timeZone: 'America/Los_Angeles',
    hi2Interfaces: [],
    hi3Interfaces: []
  };

  return {
    ...newCF,
    id: data.id,
    name: data.name,
  } as CollectionFunctionFormData;
}

export function getAuditDetailsToSubmit(
  data: XtpXdpConnection,
  originalData: XtpXdpConnection | null,
  isAuditEnabled: boolean,
  userId: string,
  userName: string,
  operation: Operation,
): AuditDetails {

  let actionType = AuditActionType.COLLECTION_FUNCTION_ADD;
  let isEdit = false;
  if (operation === 'UPDATE') {
    actionType = AuditActionType.COLLECTION_FUNCTION_EDIT;
    isEdit = true;
  }

  const auditDetails = getAuditDetails(
    isAuditEnabled,
    userId,
    userName,
    getAuditFieldInfo(getCFData(data), null, isEdit, originalData),
    data.name,
    AuditService.CF,
    actionType,
  );
  return auditDetails as AuditDetails;
}

export function getProtocolAuditDetailsToSubmit(
  data: XtpXdpConnectionProtocol,
  originalDigitExtractionServerFormData: XtpXdpConnectionProtocol | null,
  isAuditEnabled: boolean,
  userId: string,
  userName: string,
  operation: Operation,
): AuditDetails {

  let actionType = AuditActionType.XTP_XDP_CONNECTION_PROTOCOL_ADD;
  let isEdit = false;
  if (operation === 'UPDATE') {
    actionType = AuditActionType.XTP_XDP_CONNECTION_PROTOCOL_EDIT;
    isEdit = true;
  }

  const auditDetails = getAuditDetails(
    isAuditEnabled,
    userId,
    userName,
    getAuditFieldInfo(data, null, isEdit, originalDigitExtractionServerFormData),
    data.id,
    AuditService.XTP_XDP_CONNECTION_PROTOCOL,
    actionType,
  );
  return auditDetails as AuditDetails;
}

export function getProtocolsDataToSubmit(
  data: {
    main: XtpXdpConnection;
    protocols: XtpXdpConnectionProtocol[];
  },
  protocolsMap?: Partial<{ [key: string]: XtpXdpConnectionProtocol}>,
  ): XtpXdpConnectionProtocol[] {

  const clonedProtocols = cloneDeep(data.protocols)
    .map((item) => ({
      ...item,
      ipduid: data.main.ipduid,
      destIp: data.main.destIp,
      lbid: data.main.lbid,
    }));

  if (protocolsMap == null) {
    return clonedProtocols;
  }

  const protocolsToDelete = Object.keys(protocolsMap)
    .filter((key) => protocolsMap?.[key]?.operation === 'DELETE')
    .map((key) => protocolsMap[key]) || [];

  if (protocolsToDelete.length <= 0) {
    return clonedProtocols;
  }

  return [
    ...(protocolsToDelete as XtpXdpConnectionProtocol []),
    ...clonedProtocols,
  ];
}
